/* eslint-disable react/jsx-props-no-spreading */
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, { useMemo, useState, useCallback } from 'react';

import * as AppPropTypes from '../../lib/PropTypes';

import FilmCarousel from '../lists/FilmCarousel';

import styles from '../../../styles/cards/bundle.module.scss';

const propTypes = {
    item: AppPropTypes.film,
    shuffle: PropTypes.bool,
    openFilmModal: PropTypes.func,
    isModal: PropTypes.bool,
    withoutShortTitle: PropTypes.bool,
    className: PropTypes.string,
};

const defaultProps = {
    item: null,
    shuffle: false,
    openFilmModal: null,
    isModal: false,
    withoutShortTitle: false,
    className: null,
};

const SectionCard = ({ item, shuffle, openFilmModal, isModal, withoutShortTitle, className }) => {
    const {
        title = null,
        shortTitle = null,
        description = null,
        films: initialFilms = null,
        url,
    } = item || {};

    const [films, setFilms] = useState(initialFilms);

    const query = useMemo(() => {
        const { id: sectionId, edition = null } = item || {};
        const { id: editionId = null } = edition || {};
        return {
            section: sectionId,
            edition: editionId,
            // randomize: shuffle,
        };
    }, [item, shuffle]);

    const onLoad = useCallback(
        (items) => {
            if (items !== null) {
                setFilms(items);
            }
        },
        [setFilms],
    );

    const openModal = useCallback(
        (newItem, props) => {
            if (openFilmModal !== null && films.length > 0 && isModal) {
                openFilmModal(newItem, {
                    items: films,
                    heading: { title, description, url, type: 'section' },
                    ...props,
                });
            }
        },
        [films, item, openFilmModal, isModal],
    );

    return (
        <div
            className={classNames([
                styles.container,
                {
                    [className]: className !== null,
                },
            ])}
        >
            <FilmCarousel
                title={withoutShortTitle ? title || null : shortTitle || title}
                description={description}
                items={initialFilms}
                link={url}
                query={query}
                isDark
                lazyLoad
                onLoad={onLoad}
                count={50}
                cardProps={{
                    openFilmModal: openModal,
                }}
                withFilmRefs
            />
        </div>
    );
};

SectionCard.propTypes = propTypes;
SectionCard.defaultProps = defaultProps;

export default SectionCard;
